import styled from '@emotion/styled';
import { animateDarkBg, animateSlideUp, textureSvg } from '@shared/constants/Styles';
import TextButton from '../button/TextButton';
import { ContentButton, SecondaryText } from './ContentTypography';
import { BodyLarge, TextSize200 } from './Typography';

export const LandingBodyLarge = styled(BodyLarge)`
    text-align: center;
    position: relative;
    top: -15px;
`;

export const LandingButton = styled(ContentButton)`
    z-index: 2;
    position: relative;
    margin: 1rem 0 0.5rem 0;
`;

export const LandingTextButton = styled(TextButton)`
    z-index: 2;
    ${TextSize200}
    font-weight: 400;
    text-decoration: underline !important;
    :hover {
        text-decoration: none !important;
    }
`;

export const LandingOnboardingCard = styled.div`
    position: relative;
    flex: 1;
    max-width: 800px;
    align-self: stretch;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    margin: auto;
    background-color: transparent;
    @media (prefers-reduced-motion: no-preference) {
        animation-name: ${animateSlideUp};
        animation-duration: 3.5s;
    }
`;

export const LandingBase = styled.div`
    // height minutes the height of the footer and toolbar
    min-height: calc(100vh - 230px);
    flex: 1;
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.theme.color.background};
    animation-name: ${animateDarkBg};

    animation-duration: 300ms;
    :before {
        background-image: ${textureSvg};
        background-size: 100%;
        position: fixed;
        top: 60vh;
        right: -60vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
        pointer-events: none;
    }
    :after {
        transform: rotate(180deg);
        background-image: ${textureSvg};
        background-size: 100%;
        position: fixed;
        top: -1000px;
        left: -70vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
        pointer-events: none;
    }
`;

export const InlineBodyMedium = styled(SecondaryText)`
    display: inline-block;
    text-align: center;
    font-weight: 400;
    z-index: 2;
    position: relative;
`;

export const LandingContentLayout = styled.div`
    background-color: ${(props) => props.theme.color.background}90;
    padding: 2rem;
    border-radius: 8px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
